import React, { Component } from "react";

class Check extends Component {
  state = {};

  render() {
    const { id, title, narrative_text, parent_question_id,required_input,required_input_label } = this.props.item;
    const { i , multiSelect , validation_rules , prefix , postfix , single_line_text } = this.props;
    const sort_order =this.props.sort_order;
    const requiredInputValue = 1;
    return (
      <React.Fragment>
        <li>
          <div className="checbox">
            {multiSelect}
            <input
              className="custom--checkbox"
              data-key={i}
              data-id={id}
              onChange={this.props.addCurrentOptionAnswers.bind(
                this,
                id,
                i,
                narrative_text,
                parent_question_id,
                required_input,
                sort_order,multiSelect,prefix,postfix,single_line_text
              )}
              id={"checkbox-" + i}
              type={multiSelect ? "checkbox" : "radio"}
              name={multiSelect ? i : "option"}
              checked={this.props.checked}
            />
            <label htmlFor={"checkbox-" + i} className={multiSelect ? "checkbox" : "radio"}>{title}
            {
              (this.props.checked && required_input==requiredInputValue) &&
              <div className={"custom-input-box"}>
                <input placeholder={required_input_label} className={"form-control custom-input"} id={id} onChange={(event)=>{ this.props.addInputTextInOptionAnswers(event,multiSelect,id,this.props.item) }} value={this.props.displayInputText(id)} name="required_input"/>
                {validation_rules ? this.props.validator.message('required_input', this.props.displayInputText(id),  validation_rules ) : null}

              </div>
            }
            </label>
            
           
          </div>
        </li>
      </React.Fragment>
    );
  }
}

export default Check;
